import React from 'react';
import { Grid, GridContainer } from 'src/shared/grid';

export const ApiGenNotAuth: React.FC = () =>{
  return(
      <GridContainer className="margin-top-6">
          <Grid row gap="md">
              <Grid
                  desktop={{ col: 12 }}
                  className="display-flex flex-row flex-align-center flex-justify margin-bottom-205 padding-top-3">
                  <span className="font-sans-2xl text-bold">FEMS API Key Generator</span>
              </Grid>
          </Grid>

          <Grid row gap="lg" id={'data-sets'}>
              <Grid desktop={{ col: 12 }} className="padding-bottom-2">
                Please log into FEMS with a user account that has the FEMS API role to generate an API key for use in other applications.
              <br></br><br></br>
              <strong>NOTE:</strong> If you do not have a FEMS user account, log into the <a href="https://famauth.wildfire.gov">FAMAuth</a>, select the FEMS tile, and follow the process to request access to the FEMS application with the FEMS API role.
              <br></br><br></br>
                If you have a FEMS user account that does not have the FEMS API role, please request the FEMS API role through FamAuth or contact your agency's FEMS business lead.
              </Grid>
          </Grid>
      </GridContainer>
  )
}